module.exports = "pegasus/assets/preview-6.png";